var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteBasket(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.89375 13.75C1.58438 13.75 1.31953 13.6398 1.09922 13.4195C0.878906 13.1992 0.76875 12.9344 0.76875 12.625V1.9375H0V0.8125H3.525V0.25H8.475V0.8125H12V1.9375H11.2313V12.625C11.2313 12.925 11.1188 13.1875 10.8938 13.4125C10.6688 13.6375 10.4062 13.75 10.1063 13.75H1.89375ZM10.1063 1.9375H1.89375V12.625H10.1063V1.9375ZM3.88125 11.0125H5.00625V3.53125H3.88125V11.0125ZM6.99375 11.0125H8.11875V3.53125H6.99375V11.0125Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteBasket);
export default __webpack_public_path__ + "static/media/delete_basket.3853c6f2973dba2c54d4b105761214e2.svg";
export { ForwardRef as ReactComponent };